import React, { useRef } from 'react';
import { MaskedInput } from 'react-text-mask-modern';
import { classes } from '../utils';

interface ICustomInputProps {
  type: string;
  value: string | boolean;
  ModuleClassName: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  error?: string;
  name?: string;
  mask?: string;
  id?: string;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}
const MaskedInputField: React.FC<ICustomInputProps> = ({
  type,
  value,
  onChange,
  label,
  error,
  name,
  ModuleClassName,
  id,
  onBlur,
}) => {
  const previousValueRef = useRef(value === '' ? '(___) ___-____' : value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    // Only call onChange if the actual user input value has changed
    if (newValue !== previousValueRef.current) {
      previousValueRef.current = newValue; // Update the previous value
      onChange?.(event); // Call the onChange handler if provided
    }
  };
  const phoneNumberMask = [
    '(',
    /[0-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  return (
    <div
      className={classes(
        ModuleClassName,
        'mfrmFormGroup maskedPhoneNumber',
        error ? 'formError' : '',
      )}
      id={`${id}_container`}
    >
      {error && <p id={`error_${id}`}>{error}</p>}
      <MaskedInput
        mask={phoneNumberMask}
        pattern="\d" // Add pattern prop
        name={name}
        placeholderChar="_"
        inputMode="numeric"
        id={id}
        type={type}
        value={`${value}`}
        onChange={handleChange}
        aria-invalid={!!error}
        aria-required="true"
        onBlur={onBlur}
        placeholder="(___) ___-____"
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default MaskedInputField;
